<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G7E8K6/tc-custom/9798337200262.jpg?1736959363929" alt="This image is the cover for the book Eighty-Minute Hour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eighty-Minute Hour
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Survivors of nuclear war endure strange adventures across time and space in this humorous classic by a Grand Master of Science Fiction.</b><br/><br/> World War III is coming to an end, but the real chaos is just beginning. Nuclear warfare during the conflict has given rise to a disturbance in the fabric of space and time. Time-turbulences run rampant, sending whatever is caught in their trap to different times and locations. Survivors find themselves in the past, present, or future—or on other planets. Leaders across the globe, as well as an advanced AI system, are all vying to learn as much as possible about these time anomalies—and exploit them as best they can. But the disappearance of a mega-industrialist could have some answers . . .<br/><br/> Meanwhile, a band of heroes embarks on a perilous quest in an alternate world of swords and sorcery. A mad scientist is wreaking havoc on Mars. And just about everyone is bursting whimsically into song. Who knows if the mayhem will ever subside . . .<br/><br/><b>“Offers some wild entertainment . . . the whizzing energy behind all these time-warps and dirty deterministic work at the cosmic crossroads is something to wonder at.” —<i>The Guardian</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian W. Aldiss
      </h2>
      
      <p class="authorDescription body article">Brian W. Aldiss was born in Norfolk, England, in 1925. Over a long and distinguished writing career, he published award‑winning science fiction (two Hugo Awards, a Nebula Award, and the John W. Campbell Memorial Award); bestselling popular fiction, including the three‑volume Horatio Stubbs saga and the four‑volume the Squire Quartet; experimental fiction such as <I>Report on Probability A</I> and <I>Barefoot in the Head</I>; and many other iconic and pioneering works, including the Helliconia Trilogy. He edited many successful anthologies and published groundbreaking nonfiction, including a magisterial history of science fiction (<I>Billion Year Spree</I>, later revised and expanded as <I>Trillion Year Spree</I>). Among his many short stories, perhaps the most famous was &ldquo;Super‑Toys Last All Summer Long,&rdquo; which was adapted for film by Stanley Kubrick and produced and directed after Kubrick&rsquo;s death by Steven Spielberg as <I>A.I. Artificial Intelligence</I>.&#160;Brian W. Aldiss passed away in 2017 at the age of 92.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2064dd11